// @flow

import moment from 'moment'
import 'moment/locale/de'
import 'moment/locale/en-gb'
import i18nx from '@vimcar/shared-utils/i18nx'

import translationsDeDe from './translations/de.json'
import translationsEnGb from './translations/en.json'

const LANGUAGE_CODE_DE_DE = 'de-DE'
const LANGUAGE_CODE_EN_GB = 'en-GB'

const defaultLanguage = LANGUAGE_CODE_EN_GB

export const languages = {
  [LANGUAGE_CODE_DE_DE]: 'Deutsch',
  [LANGUAGE_CODE_EN_GB]: 'English',
}

const languageMap = {
  de: LANGUAGE_CODE_DE_DE,
  en: LANGUAGE_CODE_EN_GB,
}

i18nx.addResources(LANGUAGE_CODE_DE_DE, translationsDeDe)
i18nx.addResources(LANGUAGE_CODE_EN_GB, translationsEnGb)

i18nx.changeLanguage(defaultLanguage)
moment.updateLocale(defaultLanguage)

global.i18nx = i18nx

export default i18nx

export const setLanguage = (locale: string): void => {
  let language = defaultLanguage
  const [languageCandidate] = locale.toLowerCase().split(/[-_]/)

  if (languageCandidate in languageMap) {
    language = languageMap[languageCandidate]
  }

  i18nx.changeLanguage(language)
}
